import requireString from 'require-from-string'
import { transform } from 'sucrase'

export function compileTsFile(contents: string): unknown {
	const { code } = transform(contents, {
		transforms: ['typescript', 'imports'],
	})

	const result = requireString(code).default
	return result
}
